import type { Lesson, LessonUpdate } from '@/types/lesson'

// Backend treats PUT /gamified-courses/lessons/{id} as a full replace: fields
// missing from the body are reset to defaults (e.g. order → 0, which shuffles
// lesson ordering). Until the backend supports partial updates, every lesson
// update must send the complete set of LessonBase fields.
export function buildLessonUpdate(
  lesson: Omit<Lesson, 'blocks'>,
  patch: LessonUpdate,
): LessonUpdate {
  return {
    order: lesson.order,
    name: lesson.name,
    nameEn: lesson.nameEn,
    description: lesson.description,
    descriptionEn: lesson.descriptionEn,
    image: lesson.image,
    imageEn: lesson.imageEn,
    imagePrompt: lesson.imagePrompt,
    imagePromptEn: lesson.imagePromptEn,
    theme: lesson.theme,
    reward: lesson.reward,
    submoduleNumber: lesson.submoduleNumber,
    submoduleTitle: lesson.submoduleTitle,
    submoduleTitleEn: lesson.submoduleTitleEn,
    type: lesson.type,
    inventoryItemId: lesson.inventoryItemId,
    ...patch,
  }
}
